export function getPluginUrl(id) {
    return `/plugins/${encodeURIComponent(id)}`;
}
export function getPluginVersionTitle(plugin) {
    if (plugin.minVersion && plugin.maxVersion && plugin.minVersion !== plugin.maxVersion) {
        return `${plugin.minVersion} - ${plugin.maxVersion}`;
    }
    return plugin.minVersion || plugin.maxVersion || '';
}
